<template>
  <div class="member-list">
    <div class="table-search">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button
            type="primary"
            v-if="isShowAdd"
            @click="handleAdd"
          >添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.cardUrl" alt class="memberImg" />
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.cardState">上架</span>
            <span v-else>下架</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span class="editor" @click="handleEditor(scope.row.id)">编辑</span>
            <span class="view" @click="handlePreview(scope.row)">预览</span>
            <span
              class="upShelves"
              v-if="!scope.row.cardState"
              @click="handleShelves"
            >上架</span>
            <span class="downShelves" v-else @click="handleShelves">下架</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Preview
      :visible="previewVisible"
      :selectId="currentCellId"
      @close="handleClosePreview"
    />
  </div>
</template>
<script>
import Preview from '@/components/h5/cardPage.vue';
import { getUserCard, updateUserCardUpAndDown } from '@/api/prefer';
import preview from '@/mixins/mobile';

export default {
  mixins: [preview],
  data() {
    return {
      currentCellId: 0,
      previewVisible: false,
      isShowAdd: false,
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 20,
    };
  },
  components: {
    Preview,
  },
  mounted() {
    this.getUserCard();
  },
  methods: {
    // 查询会员卡配置列表
    getUserCard() {
      this.loading = true;
      getUserCard().then((res) => {
        if (res.success) {
          if (res.data) {
            this.tableData = [res.data];
          }
          this.isShowAdd = this.tableData.length === 0;
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 上下架
    handleShelves() {
      updateUserCardUpAndDown().then((res) => {
        if (res.success) {
          this.$message.success('操作成功');
          this.getUserCard();
        }
      });
    },
    // 添加会员卡
    handleAdd() {
      this.$router.push({ name: 'preferConfigAdd' });
    },
    // 编辑
    handleEditor(id) {
      this.$router.push({
        name: 'preferConfigAdd',
        query: {
          id,
        },
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.demo-form-inline
  flex-row()
  justify-content flex-end
.view, .editor, .upShelves, .downShelves
  color #1890ff
  cursor pointer
.view, .editor, .upShelves,.downShelves
  margin-right 20px
.memberImg
  width 150px
  height 100px
</style>
